import { lazy } from "react";
import { AppRoute } from "../../../types/common";

const QRCode = lazy(() => import("./QRCode"));

const OutputRoutes: AppRoute[] = [
  {
    path: "/qrcodes",
    component: <QRCode />,
    exact: true,
  },
];

export default OutputRoutes;
